import React from "react";

const Footer = () => <div className="mt-24"></div>;

export default Footer;
